module.exports = __webpack_public_path__ + "img/1440.ef74eb3b.jpg";